/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tea_Purchases_ProcessingInputs */

const vi_nav_tea_purchases_processing = /** @type {(inputs: Nav_Tea_Purchases_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản xuất chè`)
};

/**

* @param {Nav_Tea_Purchases_ProcessingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tea_purchases_processing = /** @type {((inputs?: Nav_Tea_Purchases_ProcessingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tea_Purchases_ProcessingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tea_purchases_processing(inputs)
});